import React from "react";
import GestureButton from "./GestureButton";
import { Action } from "../karaoke/actions";

export default function NextControl({ activeAction, onTrigger, className }) {
  return (
    <GestureButton
      action={Action.NEXT}
      label="Next"
      emoji="✌️"
      activeAction={activeAction}
      onTrigger={onTrigger}
      className={className}
    />
  );
}
